export const GET_CAREERS_STATED = "GET_CAREERS_STATED";
export const GET_CAREERS = "GET_CAREERS";
export const GET_CAREERS_ENDED = "GET_CAREERS_ENDED";
export const ADD_CAREER_STATED = "ADD_CAREER_STARTED";
export const ADD_CAREER = "ADD_CAREER";
export const ADD_CAREER_ENDED = "ADD_CAREER_ENDED";
export const EDIT_CAREER_STATED = "EDIT_CAREER_STATED";
export const EDIT_CAREER = "EDIT_CAREER";
export const EDIT_CAREER_ENDED = "EDIT_CAREER_ENDED";
export const GET_CAREER = "GET_CAREER";
export const GET_CAREER_STATED = "GET_CAREER_STATED";
export const GET_CAREER_ENDED = "GET_CAREER_ENDED";
export const RESET_CAREER = "RESET_CAREER";
export const ERROR_CAREER = "ERROR_CAREER";
export const GET_ALL_CAREERS_STATED = "GET_ALL_CAREERS_STATED";
export const GET_ALL_CAREERS = "GET_ALL_CAREERS";
export const GET_ALL_CAREERS_ENDED = "GET_ALL_CAREERS_ENDED";
